<template>
  <div class="left padding">
    <h2 class="titles">
      {{ this.$t("consultaFichero.titulo2") }}
    </h2>
    <SelectButton
      class="optionsContainer"
      v-model="showDrafts"
      optionLabel="label"
      optionValue="value"
      :options="selectOptions"
    />

    <ConsultasMain v-if="showDrafts === 'consultas'" />
    <Borradores v-if="showDrafts === 'borradores'" type="consulta" />
  </div>
</template>

<script>
import { GET_USUARIO_BY_UUID } from "@/graphQLQueries/UsuarioQueries";
import Borradores from "@/components/portal-cliente/Expedientes/Borradores";
import ConsultasMain from "./ConsultasMain";
import RoutesMixin from "@/utils/routes";
import DatesMixin from "@/utils/dates";

export default {
  name: "ConsultasTabMain",
  mixins: [DatesMixin, RoutesMixin],
  props: {},
  components: {
    Borradores,
    ConsultasMain,
  },
  data() {
    return {
      showDrafts: "consultas",
      usuario: {},
      idLegalCliente: "",
      idLegalUsuario: "",
      selectOptions: [
        { label: "Consultas", value: "consultas" },
        { label: "Borradores", value: "borradores" },
      ],
    };
  },
  apollo: {
    usuario: {
      query: GET_USUARIO_BY_UUID,
      variables() {
        return {
          uuidUsuario: this.$store.state.profile.uuid,
          idioma: this.$i18n.locale,
        };
      },
      fetchPolicy: "no-cache",
      update(data) {
        let user = data.getUsuarioUuid;
        if (typeof user !== undefined && user.clienteIdLegal) {
          this.idLegalCliente = user.clienteIdLegal;
          this.idLegalUsuario = user.clienteIdLegal;
        }

        return user;
      },
    },
  },
  watch: {
    showDrafts(newValue, oldValue) {
      if (newValue == null) {
        this.showDrafts = oldValue;
      }
    },
  },
  methods: {},
  created() {
    this.showDrafts = this.$route.params["subTab"] || this.showDrafts;
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
.padding {
  padding: 2%;
}
</style>